import { CalculatorForm } from "../formValues";
import { CalculatePriceRequest } from "../types";

export const calculatorForm_To_CalculatePriceRequest = (
  formData: CalculatorForm
): CalculatePriceRequest => ({
  Departure: formData.Departure!.defaultAddress,
  Destination: formData.Arrival!.defaultAddress,
  Weight: formData.Weight!,
  Volume: formData.Volume!,
  IsIMO: formData.IsDangerous,
  IsFragile: formData.IsFragile,
  IsFrozen: formData.IsTemperatureControlled,
  UseCompany: formData.UseCompany,
});
